<h3 mat-dialog-title class="modal-title title-text">{{dialogOptions.title}}</h3>
<div mat-dialog-content>
    <p class="subtitle-text">{{dialogOptions.message}}</p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-button (click)="ok()">Ok</button>
</div>